import React, { memo, useCallback } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import classnames from 'classnames';

import { ListItem, ListItemSecondaryAction, ListItemText } from '../../material-ui/List';
import { downloadDefect } from '../../../actions/defects';
import { downloadDocument, showPdf } from '../../../actions/documents';
import { DocumentPrefix } from '../../../service/constants';
import { stopPropagation } from '../../../service/eventHandlers';
import { ContentType } from '../constants';
import { useStyles } from './useStyles';

export const AttachmentItem = memo((props) => {
    const {
        contentType,
        id,
        primaryTextStyle,
        primaryText = '',
        secondaryText = '',
        isDownloaded,
        download,
        downloadFormat = 'DD.MM.YYYY',
        downloadPreifix = '',
        className,
    } = props;
    const dispatch = useDispatch();
    const classes = useStyles(isDownloaded)();

    const handleClick = useCallback(
        (evt) => {
            stopPropagation(evt);

            if (isDownloaded) {
                dispatch(showPdf(`${contentType === ContentType.LIMITATIONS ? DocumentPrefix.DEFECT: ''}${id}`));
            } else {
                if (contentType === ContentType.DOCUMENTS) {
                    dispatch(downloadDocument(id, primaryText));
                } else if (contentType === ContentType.LIMITATIONS) {
                    dispatch(downloadDefect(id, primaryText));
                }
            }
        },
        [id, contentType, isDownloaded, primaryText]
    );

    return (
        <ListItem id={id} className={classnames(classes.document, className)} onClick={handleClick} button={true}>
            <ListItemText
                className={classes.text}
                primary={primaryTextStyle ? <span style={primaryTextStyle}>{primaryText}</span> : primaryText}
                secondary={secondaryText}
            />
            <ListItemSecondaryAction className={classes.downloadStatus}>
                {isDownloaded && `${downloadPreifix}${moment.utc(download).format(downloadFormat)}`}
            </ListItemSecondaryAction>
        </ListItem>
    );
});

AttachmentItem.displayName = 'AttachmentItem';
